import { Component, OnInit } from '@angular/core';

import { UtilService } from './core/services/util.service';
import { environment } from 'src/environments/environment';
import { NavigationEnd, Router } from '@angular/router';
import { filter, pairwise } from 'rxjs';
import { RestAPIsService } from './core/services/rest-apis.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'low-carbon-recommendation';
  tncUrl = environment.tncUrl;
  spinnerSrc: string = '';
  constructor(
    private util: UtilService,
    private router: Router,
    private restAPI: RestAPIsService
  ) {
    this.util.configureApplication();
  }

  ngOnInit() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        pairwise() 
      )
      .subscribe(([prev, curr]: [NavigationEnd, NavigationEnd]) => {
        if(!prev.url.includes('/login/')){
          this.restAPI.addCheckpoint({ event: this.restAPI.getLastSegment(curr.url), source : this.restAPI.getLastSegment(prev.url) });
        }
      });
    this.spinnerSrc = `<img class='spinner-load mb-4' src="assets/images/common/Spinner.svg" alt='spinner'>`;
    this.util.configureApplication();
  }
}
